import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class InfoBox extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            visible: false,
            timer: null
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.lastError !== prevProps.lastError && typeof this.props.lastError !== "undefined" && this.props.lastError !== null) {
            if(this.state.timer) {
                clearTimeout(this.state.timer);
                this.setState({timer: null})
            }

            this.setState({
                error: this.props.lastError ? this.props.lastError : prevProps.lastError,
                visible: true,
                timer: setTimeout(() => this.setState({timer:null, visible: false}) , 8000)
            })
        }
    }

    render() {
        return (
            this.state.visible ? <div className="InfoBox">
                {this.state.error ? <React.Fragment>
                    <i className="fas fa-exclamation-triangle"/> {this.state.error}</React.Fragment>: null
                }
            </div> : null
        );
    }
}

const mapStateToProps = state => {
    return {
        lastError: state.lastError
    };
};

export default withRouter(connect(mapStateToProps)(InfoBox));



// WEBPACK FOOTER //
// ./src/components/info-box/InfoBox.js